
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Make sure React and Fragment are explicitly available to the window
if (!window.React) {
  window.React = React;
}

// Make sure Fragment is explicitly available
if (!React.Fragment) {
  console.warn('React.Fragment is not available, providing fallback');
  // @ts-ignore - Adding Fragment to React for compatibility
  React.Fragment = ({ children }) => children;
}

// Make jsx-runtime's Fragment export available
if (typeof window !== 'undefined') {
  window.__REACT_FRAGMENT = React.Fragment;
}

// Preload critical resources
const preloadResources = () => {
  // Preload fonts
  const fontLink = document.createElement('link');
  fontLink.rel = 'preload';
  fontLink.href = '/fonts/inter-var.woff2';
  fontLink.as = 'font';
  fontLink.type = 'font/woff2';
  fontLink.crossOrigin = 'anonymous';
  document.head.appendChild(fontLink);

  // Preload CSS
  const cssLink = document.createElement('link');
  cssLink.rel = 'preload';
  cssLink.href = '/src/index.css';
  cssLink.as = 'style';
  document.head.appendChild(cssLink);

  // Preload main script
  const scriptLink = document.createElement('link');
  scriptLink.rel = 'modulepreload';
  scriptLink.href = '/src/main.tsx';
  scriptLink.crossOrigin = 'anonymous';
  document.head.appendChild(scriptLink);
};

// Execute preload before rendering
preloadResources();

// Create root and render
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Ensure jsx-runtime's Fragment export is available
window.__REACT_FRAGMENT = React.Fragment;

// Define showBody function before using it
const showBody = () => {
  document.body.classList.add('ready');
};

// Use requestIdleCallback for better performance
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    showBody();
  });
} else {
  // Fallback for browsers that don't support requestIdleCallback
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  showBody();
}
